import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { CDN_URL, COLORS } from '../../modules/vars'

interface SignUpLogoProps {
  type: 'kakao' | 'naver' | 'google' | 'facebook' | 'apple'
  size?: 'sm' | 'lg'
  text?: string
  clx?: string
  dataRef?: string
  onClick?: () => void
  addOnClick?: () => void
}

const SignUpLogo = ({ type, size = 'sm', text, clx, dataRef, onClick, addOnClick }: SignUpLogoProps) => {
  const [isMobile, setIsMobile] = useState(false)

  const COLOR_OPTION = {
    kakao: '#ffe900',
    naver: '#04c75a',
    google: COLORS.WHITE,
    facebook: '#0080f9',
    apple: '#000000',
  }

  const LOGO_OPTION = {
    kakao: '/logo/ico-kakaotalk.svg',
    naver: '/logo/ico-naver.svg',
    google: '/logo/ico-google.svg',
    facebook: '/logo/ico-facebook.svg',
    apple: '/logo/ico-apple.svg',
  }

  const handleOnClick = (defaultOnclick, additionalOnclick) => {
    defaultOnclick && defaultOnclick()
    additionalOnclick && additionalOnclick()
  }

  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])

  return (
    <div
      onClick={() => handleOnClick(onClick, addOnClick)}
      style={{
        minWidth: size === 'sm' ? 56 : isMobile ? '100%' : 405,
        minHeight: 56,
        borderRadius: size === 'sm' ? '50%' : 5,
        backgroundColor: COLOR_OPTION[type],
      }}
      className={classNames(
        clx,
        [type === 'google' && 'border border-gray-300'],
        'flex cursor-pointer items-center justify-center'
      )}
      data-ref={dataRef}
    >
      <img style={{ width: 30, height: 30 }} src={`${CDN_URL}${LOGO_OPTION[type]}`} alt="" />
      {text && (
        <div
          className={classNames(
            [
              type === 'naver' && 'text-white',
              type === 'kakao' && 'text-black',
              type === 'google' && size != 'lg' && 'text-white',
              type === 'google' && size == 'lg' && 'text-black',
              type === 'facebook' && 'text-white',
              type === 'apple' && 'text-white',
            ],
            'display-9 ml-[10px]'
          )}
        >
          {type === 'apple' ? <button>{text}</button> : <>{text}</>}
        </div>
      )}
    </div>
  )
}

export default SignUpLogo
